import { useState, useMemo, useRef } from 'react';
import throttle from 'lodash/throttle';
import { useResizeObserver } from '../useResizeObserver';
import { useLayoutEffectWithoutSSRComplaining } from '../useLayoutEffectWithoutSSRComplaining';
// an optional cache to keep measurements while component is unmounted
// this allows to immediately start in the right state while mounting,
// without needing to wait for the measurement
// make sure the key use is unique enough for the instance you are caching
// it for (eg. deviationid by itself is not enough, componentname-deviationid
// might work)
const cache = {};
export function useIsOverflowed(ref, throttleTimeout = 300, cacheKey) {
    const isReady = useRef(false);
    var ref1;
    const [isOverflowed, setIsOverflowed] = useState((ref1 = cache[cacheKey !== null && cacheKey !== void 0 ? cacheKey : '']) !== null && ref1 !== void 0 ? ref1 : false);
    const measure = useMemo(()=>{
        return throttle(()=>{
            const contentNode = ref.current;
            const containerNode = contentNode === null || contentNode === void 0 ? void 0 : contentNode.parentNode;
            if (!contentNode || !containerNode) {
                return;
            }
            const isOverflowedNow = contentNode.getBoundingClientRect().height > containerNode.getBoundingClientRect().height;
            setIsOverflowed(isOverflowedNow);
            if (cacheKey) {
                cache[cacheKey] = isOverflowedNow;
            }
        }, throttleTimeout, {
            trailing: true
        });
    }, [
        throttleTimeout,
        ref,
        cacheKey
    ]);
    useResizeObserver(ref, measure);
    useLayoutEffectWithoutSSRComplaining(()=>{
        measure();
        isReady.current = true;
    }, [
        measure
    ]);
    return {
        isOverflowed,
        isReady: isReady.current
    };
}
